import { FC } from 'react';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    showAdd: () => void;
};

export const PublicMinistryCrudAddButton: FC<propsType> = ({ showAdd }) => {
    const isMobile = useGetIsMobile();

    return (
        <div style={{ position: 'fixed', width: '100%', zIndex: 4 }}>
            <div
                style={{
                    right: isMobile ? '0' : '18px',
                    marginTop: '110px',
                    pointerEvents: 'none',
                    position: 'fixed',
                    top: 0,
                    zIndex: 3
                }}
            >
                <div style={{ pointerEvents: 'auto' }}>
                    <button className={`btn btn-general-red d-block mt-2 ${isMobile ? 'btn-sm' : ''}`}
                        onClick={showAdd}
                    >
                        Agregar Salida
                    </button>
                </div>
            </div>
        </div>
    )
}
